$( function() {
	var running = false;
	var choc = null;

	function getImagesGallery(append) {
		if(running) return;

		var $gal = $('ul.gallery');
		var _url = '/galerie/getimages';
		var formData = {};
		formData.page = parseInt($gal.attr('data-page')) + 1;

		$.get(_url, formData, function(res) {
			running = false;

			if(res.length) {
				if(!append) {
					$gal.empty();
					$gal.data('page', 0);
				}
				else {
					$gal.attr('data-page', formData.page);
					$gal.data('foo', 'bar');
				}
				$(res).hide().appendTo($gal).fadeIn();
				if(choc) {
					choc.api().destroy();
					choc = null;
				}
				choc = $gal.Chocolat({
					imageSelector: '.img-wrapper'
				})
				.data('chocolat');
			}
			else {
				$('body.gallery').find('.btn-load-more').addClass('disabled');
			}
		}, 'html');
	}

	$('body.gallery').find('.btn-load-more').on('click', function(e) {
		e.preventDefault();
		if(!$(this).hasClass('disabled')) {
			getImagesGallery(true);
		}
	});

	if($('body.gallery').length) {
		getImagesGallery(true);
	}

	/*
	function fadeImages($parent) {
		$lis = $parent.find('li');

		$lis.each( function() {
			$li = $(this);
			var image = document.createElement('img');
			image.src = $li.find('a').css('background-image');
			image.onload = function () {
				$li.fadeIn();
			};
		});
	}*/
});